import {FILTER_CATEGORIES} from '../../actions/types';

export default function(state = [], action){
    switch (action.type){
        case FILTER_CATEGORIES:
            return action.payload;
        default:
            break;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/CategoriesFilter/index.js